import React from 'react';
import {TableCell, TableRow} from "@mui/material";
import {formatCurrency} from "../../utils/helpers";

const SubtotalRecapRow = ({
                              category, subtotal
                          }) => {


    return <React.Fragment>
        <TableRow sx={{whiteSpace: 'nowrap'}}>
            <TableCell></TableCell>
            <TableCell colSpan={3} sx={{fontWeight: 'bold', color: 'white', background: '#ae7f32'}}>
                Sous-total TTC {category}
            </TableCell>
            <TableCell align="right" sx={{fontWeight: 'bold', color: 'white', background: '#ae7f32'}}>
                {formatCurrency(subtotal)}
            </TableCell>
        </TableRow>
    </React.Fragment>
}

export default SubtotalRecapRow;